export const EventsCities = [
    { city: "Kolkata", state: "West Bengal", country: "India" },
    { city: "Siliguri", state: "West Bengal", country: "India" },
    { city: "Darjeeling", state: "West Bengal", country: "India" },
    { city: "Puri", state: "Odisha", country: "India" },
    { city: "Mandarmani", state: "West Bengal", country: "India" },
    { city: "Kathmandu", state: "Bagmati", country: "Nepal" },
    { city: "Pokhara", state: "Gandaki", country: "Nepal" },
    { city: "Birtamod", state: "Koshi", country: "Nepal" }
];

export const EventsTypes = {
    "Wedding": {
        info: { id: "Wedding", label: "Wedding", icon: "celebration" },
        events: [{
                id: "wedding-destination",
                title: "Destination Weddings",
                slug: "destination-weddings",
                smallHero: "Royal Unions in Iconic Locales",
                description: "Specializing in palace weddings in Rajasthan and luxury beach ceremonies in Goa."
            },
            {
                id: "wedding-pre",
                title: "Pre-Wedding Functions",
                slug: "pre-wedding-events",
                smallHero: "The Celebration Before the Vows",
                description: "Exquisite management of Sangeet, Mehendi, and Haldi ceremonies with traditional flair."
            },
            {
                id: "wedding-reception",
                title: "Reception Galas",
                slug: "wedding-receptions",
                smallHero: "A Grand Start to Forever",
                description: "Designing large-scale post-wedding celebrations and premium banquet experiences."
            }
        ]
    },
    "Corporate": {
        info: { id: "Corporate", label: "Corporate", icon: "business_center" },
        events: [{
                id: "corp-launch",
                title: "Product Launches",
                slug: "product-launches",
                smallHero: "Introducing Innovation to the World",
                description: "High-impact production for automotive reveals, tech launches, and fashion previews."
            },
            {
                id: "corp-anniversary",
                title: "Corporate Anniversaries",
                slug: "corporate-anniversaries",
                smallHero: "Celebrating Years of Excellence",
                description: "Grand Annual Day celebrations and milestone events for large-scale MNCs."
            },
            {
                id: "corp-summit",
                title: "Success Summits",
                slug: "business-summits",
                smallHero: "Where Leadership Convenes",
                description: "Professional management of leadership conferences, seminars, and networking meets."
            },
            {
                id: "corp-exhibition",
                title: "Exhibition Stalls",
                slug: "exhibition-design",
                smallHero: "Architecting Brand Presence",
                description: "Custom stall design and management for trade fairs and international expos."
            }
        ]
    },
    "Private Party": {
        info: { id: "Private Party", label: "Private Party", icon: "cake" },
        events: [{
                id: "ent-concert",
                title: "Live Concerts",
                slug: "live-music-concerts",
                smallHero: "The Pulse of Live Music",
                description: "End-to-end production for musical tours and local artist performances."
            },
            {
                id: "ent-fashion",
                title: "Fashion Shows",
                slug: "fashion-runway-events",
                smallHero: "The Pinnacle of Style",
                description: "Professional runway production, lighting design, and backstage management."
            }
        ]
    },
    "Festival": {
        info: { id: "Festival", label: "Festival", icon: "festival" },
        events: [{
                id: "ent-festival",
                title: "Music Festivals",
                slug: "music-festivals",
                smallHero: "Vibrance at Scale",
                description: "Multi-stage production and logistics for large-scale music IPs and festivals."
            },
            {
                id: "niche-gov",
                title: "Government Events",
                slug: "public-sector-events",
                smallHero: "Dignified Protocol & Planning",
                description: "Expert handling of inaugurations, VIP visits, and public sector summits."
            }
        ]
    }
};